import React from "react";

import { FormControlLabel, Radio, RadioGroup, Stack } from "@mui/material";

interface Props {
  value: boolean;
  setData: (value: boolean) => void;
}

export const PickParametersSet: React.FC<Props> = ({ value, setData }) => {
  return (
    <Stack sx={{ minWidth: 450 }}>
      <RadioGroup value={value} onChange={(e) => setData(e.target.value === "true")}>
        <FormControlLabel value={true} control={<Radio />} label="Use Current Parameter Set" />
        <FormControlLabel value={false} control={<Radio />} label="Create New Parameter Set" />
      </RadioGroup>
    </Stack>
  );
};
